export default __webpack_public_path__ + "static/media/green-2.f5309ef9.svg";